module.exports = __webpack_public_path__ + "static/media/5.554dc59e.jpg";